import { ReactNode } from "react";
import { z } from "zod";

import Modal from "components/ui/modal/Modal";
import { useURLState } from "../../lib/hooks/useURLState";
import { EventNames, useTracking } from "../../lib/tracking";
import { formatDataType } from "../../lib/utils";
import BookADemoForm from "./BookADemoForm";

function BookADemoFromUrl({ children }: { children: ReactNode }) {
  const [bookADemoOpen, setBookADemoOpen] = useURLState(
    "bookADemo",
    undefined,
    z.string().optional(),
  );

  const [dataType, setDataType] = useURLState("dataType", undefined, z.string().optional());
  const contextSource = bookADemoOpen;

  const trackingData = {
    "Context source": contextSource,
    "Data type": formatDataType(dataType) ?? formatDataType(window.location.href) ?? "N/A",
  };

  const { logEvent } = useTracking();

  if (!bookADemoOpen) {
    return <>{children}</>;
  }

  logEvent(EventNames.paywallActioned, { ...trackingData, Action: "Book a demo in-app" });

  const onOpenChange = (open: boolean) => {
    if (!open) {
      logEvent(EventNames.bookADemoCancelled, trackingData);
      setDataType(undefined);
      setBookADemoOpen(undefined);
    } else {
      setBookADemoOpen("true");
    }
  };

  return (
    <>
      <Modal open={!!bookADemoOpen} onOpenChange={onOpenChange}>
        <BookADemoForm trackingData={trackingData} />
      </Modal>
      {children}
    </>
  );
}

export default BookADemoFromUrl;
